import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import Button from "components/Button";
import { MyTrucksIcon, PostTruckIcon, TruckSearchIcon } from "components/SVGIcons";
import { convertDiffToAge, parseError } from "helpers/convertFormData";
import { GridCardItem } from "models/Base";
import { ITableHeaderList } from "models/HaulPay";
import { IRegion, ITrailerType } from "models/Truck";
import { routes } from "./routes";
import { EQUIPMENT_TYPES } from "./signup";
import Icon from "@mdi/react";
import { mdiAccountOutline, mdiPhone, mdiShieldCheck } from "@mdi/js";
import Rater from "../components/Rater";
import Tooltip from "../components/Tooltip";
import FMCSALink from "../components/FMCSALink";
import { postBlockUsersAPI } from "../services/api/userSetting";
import { showErrorMessage, showSuccessMessage } from "../helpers/toastMessage";
import { useCallback } from "react";
import { useModal } from "../context/ModalContext";
import { useMutation } from "@apollo/client/react";
import { MUTATION_SAVE_TRUCK } from "../features/main/Trucks/Detail/query";

export const TRUCK_ITEMS: GridCardItem[] = [
  {
    id: 0,
    label: "Truck Search",
    icon: (props: React.SVGProps<SVGSVGElement>) => <TruckSearchIcon {...props} />,
    link: routes.TRUCKS_SEARCH
  },
  {
    id: 1,
    label: "Post Truck",
    icon: (props: React.SVGProps<SVGSVGElement>) => <PostTruckIcon {...props} />,
    link: routes.TRUCKS_POST
  },
  {
    id: 2,
    label: "My Trucks",
    icon: (props: React.SVGProps<SVGSVGElement>) => <MyTrucksIcon {...props} />,
    link: routes.TRUCKS_MY_POSTED
  }
];

export const PAGE_TAB_ITEMS = [
  {
    id: 0,
    label: "Search",
    value: "search",
    link: routes.TRUCKS_SEARCH
  },
  {
    id: 1,
    label: "Post",
    value: "post",
    link: routes.TRUCKS_POST
  }
];

export const TRUCK_FILTER_ITEMS = [
  {
    id: 0,
    label: "Age",
    value: "time_posted"
  },
  {
    id: 1,
    label: "Equipment",
    value: "trailerTypes"
  },
  {
    id: 2,
    label: "Start Date",
    value: "time_start"
  },
  {
    id: 3,
    label: "Weight",
    value: "weight"
  },
  {
    id: 4,
    label: "Length",
    value: "length"
  }
];

export const FILTER_CARRIER_LIST = [
  {
    id: 0,
    label: "Any",
    value: ""
  },
  {
    id: 1,
    label: "HaulPay Verified Only",
    value: "verified"
  }
];

export const RADIUS_DATA = [
  {
    id: 0,
    label: "200",
    value: "200"
  }
];

export const LENGTH_DATA = [
  {
    id: 0,
    label: "53",
    value: "53"
  }
];

export const REGION_DATA = [
  { id: 0, label: "Alberta", value: "AB" },
  { id: 1, label: "Aguascalientes", value: "AG" },
  { id: 2, label: "Alaska", value: "AK" },
  { id: 3, label: "Alabama", value: "AL" },
  { id: 4, label: "Arkansas", value: "AR" },
  { id: 5, label: "Arizona", value: "AZ" },
  { id: 6, label: "British Columbia", value: "BC" },
  { id: 7, label: "Baja California Norte", value: "BN" },
  { id: 8, label: "Baja California Sur", value: "BS" },
  { id: 9, label: "California", value: "CA" },
  { id: 10, label: "Coahuila", value: "CH" },
  { id: 11, label: "Chihuahua", value: "CI" },
  { id: 12, label: "Colima", value: "CL" },
  { id: 13, label: "Colorado", value: "CO" },
  { id: 14, label: "Campeche", value: "CP" },
  { id: 15, label: "Chiapas", value: "CS" },
  { id: 16, label: "Connecticut", value: "CT" },
  { id: 17, label: "District of Columbia", value: "DC" },
  { id: 18, label: "Delaware", value: "DE" },
  { id: 19, label: "Districto Federal", value: "DF" },
  { id: 20, label: "Durango", value: "DG" },
  { id: 21, label: "Florida", value: "FL" },
  { id: 22, label: "Georgia", value: "GA" },
  { id: 23, label: "Guerrero", value: "GE" },
  { id: 24, label: "Guanajuato", value: "GJ" },
  { id: 25, label: "Hidalgo", value: "HD" },
  { id: 26, label: "Hawaii", value: "HI" },
  { id: 27, label: "Iowa", value: "IA" },
  { id: 28, label: "Idaho", value: "ID" },
  { id: 29, label: "Illinois", value: "IL" },
  { id: 30, label: "Indiana", value: "IN" },
  { id: 31, label: "Jalisco", value: "JA" },
  { id: 32, label: "Kansas", value: "KS" },
  { id: 33, label: "Kentucky", value: "KY" },
  { id: 34, label: "Louisiana", value: "LA" },
  { id: 35, label: "Massachusetts", value: "MA" },
  { id: 36, label: "Manitoba", value: "MB" },
  { id: 37, label: "Michoacan", value: "MC" },
  { id: 38, label: "Maryland", value: "MD" },
  { id: 39, label: "Maine", value: "ME" },
  { id: 40, label: "Michigan", value: "MI" },
  { id: 41, label: "Minnesota", value: "MN" },
  { id: 42, label: "Missouri", value: "MO" },
  { id: 43, label: "Morelos", value: "MR" },
  { id: 44, label: "Mississippi", value: "MS" },
  { id: 45, label: "Montana", value: "MT" },
  { id: 46, label: "Mexico", value: "MX" },
  { id: 47, label: "Nayarit", value: "NA" },
  { id: 48, label: "New Brunswick", value: "NB" },
  { id: 49, label: "North Carolina", value: "NC" },
  { id: 50, label: "North Dakota", value: "ND" },
  { id: 51, label: "Nebraska", value: "NE" },
  { id: 52, label: "New Hampshire", value: "NH" },
  { id: 53, label: "New Jersey", value: "NJ" },
  { id: 54, label: "Nuevo Leon", value: "NL" },
  { id: 55, label: "New Mexico", value: "NM" },
  { id: 56, label: "Nova Scotia", value: "NS" },
  { id: 57, label: "Northwest Territories", value: "NT" },
  { id: 58, label: "Nunavut", value: "NU" },
  { id: 59, label: "Nevada", value: "NV" },
  { id: 60, label: "New York", value: "NY" },
  { id: 61, label: "Oaxaca", value: "OA" },
  { id: 62, label: "Ohio", value: "OH" },
  { id: 63, label: "Oklahoma", value: "OK" },
  { id: 64, label: "Ontario", value: "ON" },
  { id: 65, label: "Oregon", value: "OR" },
  { id: 66, label: "Pennsylvania", value: "PA" },
  { id: 67, label: "Prince Edward Island", value: "PE" },
  { id: 68, label: "Puebla", value: "PU" },
  { id: 69, label: "Quebec", value: "QC" },
  { id: 70, label: "Queretaro", value: "QE" },
  { id: 71, label: "Quintana Roo", value: "QI" },
  { id: 72, label: "Rhode Island", value: "RI" },
  { id: 73, label: "South Carolina", value: "SC" },
  { id: 74, label: "South Dakota", value: "SD" },
  { id: 75, label: "Sinaloa", value: "SI" },
  { id: 76, label: "Saskatchewan", value: "SK" },
  { id: 77, label: "San Luis Potosi", value: "SL" },
  { id: 78, label: "Sonora", value: "SO" },
  { id: 79, label: "Tamaulipas", value: "TA" },
  { id: 80, label: "Tabasco", value: "TB" },
  { id: 81, label: "Tlaxcala", value: "TL" },
  { id: 82, label: "Tennessee", value: "TN" },
  { id: 83, label: "Texas", value: "TX" },
  { id: 84, label: "Utah", value: "UT" },
  { id: 85, label: "Virginia", value: "VA" },
  { id: 86, label: "Veracruz", value: "VC" },
  { id: 87, label: "Vermont", value: "VT" },
  { id: 88, label: "Washington", value: "WA" },
  { id: 89, label: "Wisconsin", value: "WI" },
  { id: 90, label: "West Virginia", value: "WV" },
  { id: 91, label: "Wyoming", value: "WY" },
  { id: 92, label: "Yukon Territory", value: "YT" },
  { id: 93, label: "Yucatan", value: "YU" },
  { id: 94, label: "Zacatecas", value: "ZA" }
];
export const TRUCK_SEARCH_EXPANDABLE_HEADER_LIST: ITableHeaderList[] = [
  {
    value: ["user.dba", "user.id", "truckId"],
    label: "Company",
    render: ({ dba, id, truckId }: { dba: string; id: string; truckId: string }) => {
      const navigate = useNavigate();
      const { openModal, closeModal } = useModal();

      function goProfile() {
        navigate(`${routes.USER}/${id}`);
      }

      const blockTruckHandler = useCallback(async () => {
        try {
          await postBlockUsersAPI(id);
          showSuccessMessage("Successfully blocked user.");
        } catch (_error) {
          showErrorMessage("Failed to block user.");
        }
      }, [id]);

      const handleConfirmBlockUser = useCallback(
        () =>
          openModal("warning", {
            message:
              "Are you sure you want to block all posts by this user? You can manage blocked users from Settings under the Account section.",
            onConfirm: async () => {
              await blockTruckHandler();
              closeModal("warning");
            },
            onClose: () => closeModal("warning")
          }),
        [blockTruckHandler]
      );

      const [SaveTruck] = useMutation(MUTATION_SAVE_TRUCK, {
        onError(err) {
          err.graphQLErrors.map(({ message }) => showErrorMessage(parseError(message)));
        }
      });

      const createUserSavedTruck = async () => {
        try {
          await SaveTruck({
            variables: {
              truckId: truckId
            }
          });
          showSuccessMessage("Successfully saved truck.");
        } catch (error) {
          showErrorMessage("Failed to save truck.");
        }
      };

      return (
        <div className="flex flex-col flex-grow w-full h-full">
          <div className="flex items-center mt-1 w-full">
            <span className="font-bold capitalize">{dba}</span>
          </div>
          <div className="flex items-center pt-1 w-full">
            <button className="underline text-lg" onClick={goProfile}>
              View Profile
            </button>
            <button className="underline ml-2" onClick={goProfile}>
              <Icon path={mdiAccountOutline} size={1} className="text-placeholder" />
            </button>
          </div>
          <div className="flex flex-row mt-2">
            <span>Block:</span>
            <Button
              className="ml-2"
              type="button"
              variant="outline"
              size="sm"
              rounded
              onClick={handleConfirmBlockUser}>
              User
            </Button>
          </div>
          <div className="flex items-center mt-1 w-full">
            <Button type="button" variant="outline" size="md" onClick={createUserSavedTruck}>
              Save this truck
            </Button>
          </div>
        </div>
      );
    }
  },
  {
    value: [
      "user.mc",
      "user.address",
      "user.city",
      "user.state",
      "user.country",
      "user.details",
      "user.dot"
    ],
    label: "Company Information",
    render: (user: any) => (
      <div className="flex flex-col flex-grow w-full h-full mt-1">
        {user?.mc && <span className="text-lg">MC#: {user.mc}</span>}
        {user?.dot && <span className="text-lg">DOT#: {user.dot}</span>}
        {user?.details && <span className="text-lg">{user?.details}</span>}
        <span className="text-lg">
          {[user?.address, user?.city, user?.state, user?.country]
            .filter((item) => !!item && item !== undefined)
            .join(", ")}
        </span>
      </div>
    )
  },
  {
    value: ["user.dba", "user.id", "user.email", "user.contactPhone", "user.contactName"],
    label: "Contact",
    render: (user: any) => (
      <div className="flex flex-col flex-grow mt-1 w-full h-full">
        <span className="text-lg">Contact : {user.contactName}</span>
        <div className="flex">
          <span className="text-lg">Phone :&nbsp;</span>
          <a href={`tel:+1${user.contactPhone}`} className="underline text-info">
            {user.contactPhone}
          </a>
        </div>

        <div className="break-all">
          <span className="text-lg">Email :&nbsp;</span>
          <a href={`mailto:${user.email}`} className="underline text-info">
            {user.email}
          </a>
        </div>
        <div className="flex gap-2.5 mt-1.5 text-sm">
          <a
            href={`tel:+1${user.contactPhone}`}
            className="flex items-center rounded-full bg-gradient-to-r from-primary to-secondary size-11">
            <Icon path={mdiPhone} className="m-auto text-white" />
          </a>

          <a
            href={`mailto:${user.email}`}
            className=" px-5 bg-transparent border rounded-full border-primary text-primary h-11 flex items-center">
            Email
          </a>
        </div>
      </div>
    )
  },
  {
    value: [
      "user.dba",
      "user.mc",
      "user.dot",
      "user.id",
      "user.hasVerifiedEmail",
      "user.contactPhone",
      "user.averageRating"
    ],
    label: "Reporting",
    render: (user: any) => {
      const navigate = useNavigate();

      function goProfile() {
        navigate(`${routes.USER}/${user.id}`);
      }

      return (
        <div className="flex flex-col flex-grow w-full h-full">
          <div className="flex items-center w-full">
            <FMCSALink className="text-lg" dot={user.dot} mc={user.mc}>
              FMCSA Report
            </FMCSALink>
          </div>
          <div className="flex items-center w-full">
            <Button
              variant="text"
              className="!text-info !p-0 h-8 text-lg"
              onClick={() => goProfile()}>
              Rate This User
            </Button>
          </div>
          <Rater value={user.averageRating / 20} readOnly />

          {user?.hasVerifiedEmail ? (
            <Tooltip
              position="left"
              message="This carrier has been verified for liability insurance, business legitimacy and authority compliance. We still recommend verifying cargo insurance and other requirements with the carrier as needed.">
              <div className="flex items-center gap-2 mt-2">
                <Icon path={mdiShieldCheck} className="text-primary size-11" />
                <span>Haul Pay Verified Carrier</span>
              </div>
            </Tooltip>
          ) : null}
        </div>
      );
    }
  }
];

export const TRUCK_SEARCH_HEADER_LIST: ITableHeaderList[] = [
  {
    value: "timePosted",
    label: "Age",
    render: (item: string) => (
      <span>{convertDiffToAge(dayjs().diff(dayjs(item), "milliseconds"))}</span>
    )
  },
  {
    value: "trailerTypes",
    label: "Type",
    render: (item: ITrailerType[]) => (
      <span>
        {item.length > 0
          ? item
              .map(({ loadtypes }) => {
                const loadChoiceFull = EQUIPMENT_TYPES.find(
                  (type) => type.value === loadtypes
                )?.label;
                return loadChoiceFull;
              })
              .join(", ")
          : "Any"}
      </span>
    )
  },
  {
    value: "originData",
    label: "Origin",
    render: (item: any) => (
      <span>
        {item.city || item.region.length > 0
          ? `${
              (item.city ? `${item.city}, ` : "") +
              item.region.map((region: IRegion) => region.originStates).join(", ")
            }`
          : "Anywhere"}
      </span>
    )
  },
  {
    value: "originRadius",
    label: "Range",
    render: (item: string) => <span>{item ?? "Any"}</span>
  },
  {
    value: "destinationData",
    label: "Destination",
    render: (item: any) => (
      <span>
        {item.city || item.region.length > 0
          ? `${
              (item.city ? `${item.city}, ` : "") +
              item.region.map((region: IRegion) => region.destinationStates).join(", ")
            }`
          : "Anywhere"}
      </span>
    )
  },
  {
    value: "destinationRadius",
    label: "Range",
    render: (item: string) => <span>{item ?? "Any"}</span>
  },
  {
    value: "weight",
    label: "Weight"
  },
  {
    value: "length",
    label: "Length"
  },
  {
    value: "timeStart",
    label: "Ready",
    render: (item: string) => <span>{dayjs(item).format("MM/DD/YYYY")}</span>
  },
  {
    value: "timeEnd",
    label: "Close",
    render: (item: string) => <span>{dayjs(item).format("MM/DD/YYYY")}</span>
  },
  {
    value: "details",
    label: "More",
    render: (item: { action: VoidFunction }) => (
      <Button rounded variant="outline" onClick={item.action}>
        Details
      </Button>
    )
  }
];
